import React from "react";
import { useDragLayer } from "react-dnd";
import { DND_ITEM_TYPES } from "../supplyTableRow";
import DragPreviewCard from "../DragPreviewCard";

/**
 * ADD_PRODUCT_ROW タイプのドラッグ全般 (FreeProduct フィルタバー / CombinedSidebarRow)
 * 用のカスタムドラッグプレビュー。
 * レイアウト/フォントは <DragPreviewCard /> に委譲し、ここでは表示データを整形するだけ。
 *
 * 使い方: DndProvider 配下のどこか 1 箇所に <FreeProductDragPreview /> を mount するだけ。
 */
const FreeProductDragPreview = () => {
  const { isDragging, item, type, currentOffset } = useDragLayer((m) => ({
    isDragging: m.isDragging(),
    item: m.getItem(),
    type: m.getItemType(),
    currentOffset: m.getClientOffset(),
  }));

  if (!isDragging) return null;
  if (type !== DND_ITEM_TYPES.ADD_PRODUCT_ROW) return null;
  if (!currentOffset) return null;

  // CombinedSidebarRow と FreeProduct で field 名が origin / originName など
  // 両方使われているので両方対応する
  const originName = item.originName ?? item.origin ?? "";
  const rankName = item.rankName ?? item.rank ?? "";
  const productClassName = item.productClassName ?? item.productClass ?? "";
  const packingName = item.packingName ?? item.packing ?? "";
  const weightUnitName = item.weightUnitName ?? item.weightUnit ?? "";

  const specs = [originName, rankName, productClassName, packingName]
    .filter(Boolean)
    .join(" / ");

  const weightText = item.weight ? `${item.weight}${weightUnitName}` : "";
  const extra = [weightText, item.otherSpec].filter(Boolean).join(" ・ ");

  return (
    <DragPreviewCard
      currentOffset={currentOffset}
      productName={item.productName}
      specs={specs}
      extra={extra}
    />
  );
};

export default FreeProductDragPreview;
